var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _vm.type
        ? _c("header-common", {
            class: {
              "media_small_hide media_big_hide": _vm.fromSource == "app"
            },
            attrs: { pageName: _vm.currentPage, NavList: _vm.NavList }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.children != null
        ? _c("router-view", {
            class: { common_padding_top: _vm.fromSource != "app" }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.type
        ? _c("footer-common", {
            class: {
              "media_small_hide media_big_hide": _vm.fromSource == "app"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("suspen-kr", {
        class: { "media_small_hide media_big_hide": _vm.fromSource == "app" }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 